import { useState } from 'react';
import { downloadHighlights } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function DownloadSection() {
  const [toast, setToast] = useState('');

  return (
    <section id="download" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-500">
          <div className="grid grid-cols-1 items-center gap-8 p-6 md:p-10 lg:grid-cols-[1fr_1.3fr] lg:p-12">
            <Reveal>
              <div className="order-2 h-[260px] w-full overflow-hidden rounded-lg border border-primary-400 md:h-[320px] lg:order-1">
                <img
                  src="https://readdy.ai/api/search-image?query=clean%20smartphone%20mockup%20floating%20on%20a%20warm%20cream%20background%20with%20subtle%20crimson%20gradient%20glow%20at%20the%20edges%2C%20soft%20studio%20lighting%2C%20minimal%20product%20photography%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=760&height=760&seq=heiliaocom-download-app&orientation=squarish"
                  alt="黑料社区客户端界面预览"
                  title="黑料社区客户端下载 黑料社区最新回复"
                  className="h-full w-full object-top"
                />
              </div>
            </Reveal>

            <Reveal delay={100} className="order-1 lg:order-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                <i className="ri-flashlight-fill" />
                客户端更顺手
              </span>
              <h2 className="text-balance mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                把黑料社区装进手机，
                <br className="hidden sm:block" />
                新帖和最新回复第一时间送到你眼前。
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
                热帖、爆料帖、精华热榜、最新回复一个入口全收，再也不用在十几个页面之间来回找。想跟帖、想反驳、想补充线索，打开就能说。
              </p>

              <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
                {downloadHighlights.map((item) => (
                  <li key={item.title} className="rounded-md bg-primary-600 p-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded bg-primary-400 text-background-50">
                      <i className={`${item.icon} text-base`} />
                    </span>
                    <p className="mt-2 text-sm font-medium text-background-50">{item.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-primary-100">{item.desc}</p>
                  </li>
                ))}
              </ul>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="button"
                  onClick={() => setToast('演示页面：正式版这里会跳转到应用商店下载。')}
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100"
                >
                  <i className="ri-apple-fill text-lg" />
                  iOS 客户端
                </button>
                <button
                  type="button"
                  onClick={() => setToast('演示页面：正式版这里会跳转到安卓应用市场。')}
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-android-fill text-lg" />
                  Android 客户端
                </button>
                <span className="text-xs text-primary-100 sm:ml-2">v5.2.0 · 约 38MB · 支持桌面推送</span>
              </div>

              {toast && (
                <p className="mt-4 flex items-center gap-1.5 rounded-md bg-primary-600 px-3 py-2 text-xs text-background-50">
                  <i className="ri-information-line" />
                  {toast}
                </p>
              )}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}